import AccountsAddModal from "./AccountsAddModal";

export default AccountsAddModal;